import { Map } from 'immutable'

import ConversationConstants from 'constants/ConversationConstants'

const ConversationStore = Marty.createStore({
  id: 'ConversationStore',

  getInitialState() {
    return {
      conversationsById: Map(),

      searchResults: {},

      lastQueryByInboxId: Map(),
      hasMoreGroupsByInboxId: Map(),
      cursorByInboxId: Map()
    }
  },

  handlers: {
    getOrFetchConversation: ConversationConstants.CONVERSATION_FETCH,
    fetchConversationDone: ConversationConstants.CONVERSATION_FETCH_DONE,

    searchAllConversationsDone: ConversationConstants.SEARCH_ALL_CONVERSATIONS_DONE
  },

  fetchConversationsByIdDone(conversationsById) {
    conversationsById = this.state.conversationsById.merge(Map(conversationsById).mapKeys(parseInt))
    return this.setState({ conversationsById })
  },

  getOrFetchConversation(conversationId) {
    return this.fetch({
      id: `getConversation${ conversationId }`,
      locally() {
        return this.getConversationById(conversationId)
      },
      remotely() {
        return this.app.queries.ConversationQueries.fetchConversation(conversationId)
      }
    })
  },

  getConversationById(conversationId) {
    return this.state.conversationsById.get(conversationId)
  },

  fetchConversationDone(conversationId, conversation) {
    return this.setState({ conversationsById: this.state.conversationsById.set(conversationId, conversation) })
  },

  getConversationUpdateStateById() {
    return this.state.conversationUpdateStateById
  },

  searchAllConversationsDone(query, searchResult) {
    const searchResults = _.cloneDeep(this.state.searchResults)
    searchResults[query] = searchResult
    return this.setState({ searchResults })
  },

  getSearchResults() {
    return this.state.searchResults
  },

  resetSearchResults() {
    return this.setState({ searchResults: {}})
  },
})

export default ConversationStore



// WEBPACK FOOTER //
// ./src/scripts/stores/ConversationStore.js